import { render, staticRenderFns } from "./PerformanceAlertPdf.vue?vue&type=template&id=3709e4c8"
import script from "./PerformanceAlertPdf.vue?vue&type=script&lang=js"
export * from "./PerformanceAlertPdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports